// Generated by CoffeeScript 1.8.0

/*
 * Source: http://stackoverflow.com/a/11697909/607997
 * http://codepen.io/onedayitwillmake/details/EHDmw
 * by Mario Gonzalez
 */

/*
 * Solver for cubic bezier curve with implicit control points at (0,0) and (1.0, 1.0)
 */
var UnitBezier;

module.exports = UnitBezier = (function() {
  function UnitBezier(p1x, p1y, p2x, p2y) {
    this.set(p1x, p1y, p2x, p2y);
  }

  UnitBezier.prototype.set = function(p1x, p1y, p2x, p2y) {
    this._cx = 3.0 * p1x;
    this._bx = 3.0 * (p2x - p1x) - this._cx;
    this._ax = 1.0 - this._cx - this._bx;
    this._cy = 3.0 * p1y;
    this._by = 3.0 * (p2y - p1y) - this._cy;
    this._ay = 1.0 - this._cy - this._by;
  };

  UnitBezier.epsilon = 1e-6;

  UnitBezier.prototype._sampleCurveX = function(t) {
    return ((this._ax * t + this._bx) * t + this._cx) * t;
  };

  UnitBezier.prototype._sampleCurveY = function(t) {
    return ((this._ay * t + this._by) * t + this._cy) * t;
  };

  UnitBezier.prototype._sampleCurveDerivativeX = function(t) {
    return (3.0 * this._ax * t + 2.0 * this._bx) * t + this._cx;
  };

  UnitBezier.prototype._solveCurveX = function(x, epsilon) {
    var d2, i, t0, t1, t2, x2;
    t0 = void 0;
    t1 = void 0;
    t2 = void 0;
    x2 = void 0;
    d2 = void 0;
    i = void 0;
    t2 = x;
    i = 0;
    while (i < 8) {
      x2 = this._sampleCurveX(t2) - x;
      if (Math.abs(x2) < epsilon) {
        return t2;
      }
      d2 = this._sampleCurveDerivativeX(t2);
      if (Math.abs(d2) < epsilon) {
        break;
      }
      t2 = t2 - x2 / d2;
      i++;
    }
    t0 = 0.0;
    t1 = 1.0;
    t2 = x;
    if (t2 < t0) {
      return t0;
    }
    if (t2 > t1) {
      return t1;
    }
    while (t0 < t1) {
      x2 = this._sampleCurveX(t2);
      if (Math.abs(x2 - x) < epsilon) {
        return t2;
      }
      if (x > x2) {
        t0 = t2;
      } else {
        t1 = t2;
      }
      t2 = (t1 - t0) * .5 + t0;
    }
    return t2;
  };

  UnitBezier.prototype.solve = function(x, epsilon) {
    return this._sampleCurveY(this._solveCurveX(x, epsilon));
  };

  UnitBezier.prototype.solveSimple = function(x) {
    return this._sampleCurveY(this._solveCurveX(x, 1e-6));
  };

  return UnitBezier;

})();
